import { apiNa } from "@/redworks/api/index";

const SETTINGS_API = "/v1/settings";


function $getAccountConfig(){
    return apiNa.get(`${SETTINGS_API}/accountConfig`)
}

function $getSignupConfig(){
    return apiNa.get(`${SETTINGS_API}/signupConfig`)
}

function $getIdentifyConfig(){
    return apiNa.get(`${SETTINGS_API}/identifyConfig`)
}

function $getLogoConfig(){
    return apiNa.get(`${SETTINGS_API}/logoConfig`)
}

export{$getAccountConfig, $getIdentifyConfig, $getSignupConfig, $getLogoConfig}